<template>
  <div class="content">
    <div class="head_title">
      <div class="title1">大牌云集</div>
      <div class="title2">精选国内外一线家装品牌，用我的坚持，为你的品质生活打call</div>
      <div class="Scribing"></div>
    </div>
    <div class="menumodular">
      <ul>
        <li
          v-for="(item,index) in list"
          :key="index"
          @mouseenter="enter2(item)"
          @mouseleave="leave2(item)"
        >
          <div class="Outerlayer">
            <img :src="item.imgurl" />
          </div>
          <transition name="el-zoom-in-bottom">
            <div v-show="item.show" class="transition-box">
              <div class="text">{{item.text}}</div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
    <div class="tishi">*排名不分先后，仅展示部分合作品牌</div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      list: [
        {
          imgurl: require("../../assets/images/index/大牌云集/jinpaichugui.png"),

          text: "创立于1999年A股上市名企定位“更专业的高端厨柜",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/jujiamumen.png"),

          text: "金牌厨柜出品生于颜值，忠于品质",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/jujiayigui.png"),

          text: "金牌厨柜出品专业衣柜定制品牌",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/maniou.png"),
          text: "金牌厨柜出品嵌入式智能厨电一体化设计厨房美学创造者",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/nuobeier.png"),
          text: "拥有多条世界领先水平生产线中国的诺贝尔，世界的诺贝尔",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/mengnalisha.png"),
          text:
            "“中国轻工业工程技术研究中心”行业领先水平始终以艺术引领全新的消费体验",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/xinzhongyuan.png"),
          text:
            "喷墨印刷技术，使瓷砖生产从“复印机”向“打印机”转变被誉为陶瓷印刷的第三次革命",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/oceano.png"),
          text: "建有全球较大的建陶研发中心“瓷砖整体解决方案”营运服务商",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/nature.png"),
          text: "环保健康生活专家“世界优秀自然保护支持者”",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/elegantliving.png"),
          text:
            "来自于美洲、欧洲、非洲等地的优质木材；产品品质、环保性能比肩全球优秀企业！",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/beamy.png"),
          text:
            "秉承“恒于心，专于质”的品牌精神，作为国产品牌的代表，始终如一地做好卫浴产品与服务",
          show: false
        },
               {
          imgurl: require("../../assets/images/index/大牌云集/artemundi.png"),
          text:
            "西班牙乐家卫浴集团旗下品牌，拥有着全球先进生产设备；品质、设计、环保是YING的核心优势。",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/hegii.png"),
          text:
            "秉承“恒于心，专于质”的品牌精神，作为国产品牌的代表，始终如一地做好卫浴产品与服务",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/ying.png"),
          text:
            "西班牙乐家卫浴集团旗下品牌，拥有着全球先进生产设备；品质、设计、环保是YING的核心优势。",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/suncoo.png"),
          text:
            "时尚、经典、品质，打造具有时代感、品质感的生活化浴室空间，让更多的人享受更美好的生活！",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/yunmi.png"),
          text:
            "开创全屋互联网家电，通过”AI+loT”方法进行跨界整合，构建全屋智能!",
          show: false
        },
        {
          imgurl: require("../../assets/images/index/大牌云集/meierkait.png"),
          text:
            "塞氟柯林工艺和雷诺丽特覆膜双重质量认证，真正的高端厨卫吊顶!",
          show: false
        },
                {
          imgurl: require("../../assets/images/index/大牌云集/zhongke.png"),
          text:
            "全球首创防水防触电插座，并拥有四大安全结构核心技术;国家级高新技术企业。",
          show: false
        },
                      {
          imgurl: require("../../assets/images/index/大牌云集/nvc.png"),
          text:
            "建有符合欧洲标准的产品开发中心，是中国唯一真正走向国际市场、参与国际竞争的照明品牌",
          show: false
        },
                            {
          imgurl: require("../../assets/images/index/大牌云集/sankeshu.png"),
          text:
            "国内“健康漆”倡导者，通过对标美国和欧洲的先进标准，创立“健康+”新标准!",
          show: false
        },
      ]
    };
  },
  methods: {
    enter2(item) {
      item.show = true;
    },
    leave2(item) {
      item.show = false;
    }
  }
};
</script>
<style scoped>
.content {
  width: 100%;
  padding-top: 50px;
  overflow: hidden;
  background-color: #f4f4f4;
}
.menumodular {
  width: 1280px;
  margin: 0 auto;
  margin-top: 50px;
}
.menumodular > ul {
  width: 100%;
  margin: 0 auto;
  padding-inline-start: 0px;
  margin-left: -10px;
}
.menumodular > ul li {
  width: 246px;
  height: 140px;
  float: left;
  list-style: none;
  background: #fff;
  position: relative;
  margin-left: 10px;
  border-radius: 5px;
  margin-top: 10px;
}
.Outerlayer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left-title {
  font-size: 20px;
  color: #000;
  margin-top: 20px;
}
.left-Remarks {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
}
.transition-box {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  background-color: #bc001d;
  border-radius: 5px;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text {
  width: 80%;
  height: 100px;
}
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}
.tishi{
    width:1260px;height:50px;
    line-height: 50px;
    text-align: right;
    margin: 0 auto;
    font-size: 12px;
}
</style>
